module.exports = __webpack_public_path__ + "static/media/main_106.3f168035.ico";